export * from './window-type-9.component';